import { render, staticRenderFns } from "./index_family.vue?vue&type=template&id=250b71b8&"
import script from "./index_family.vue?vue&type=script&lang=js&"
export * from "./index_family.vue?vue&type=script&lang=js&"
import style0 from "./index_family.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports